import React, { useState } from "react";
import styled from 'styled-components';

const MaskedLayout = styled.div`
  i {
    font-size: 18px;
    margin-left: 5px;
  }
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const Masked = ({ value }) => {
  const [masked, setMasked] = useState(true);
  const displayValue = masked ? "•".repeat(String(value ?? "").length) : value;
  return (
    <MaskedLayout onClick={() => setMasked(!masked)}>
      {displayValue}
      <i className="material-icons">
        {masked ? "visibility" : "visibility_off"}
      </i>
    </MaskedLayout>
  );
};

export default Masked;